import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { AuthShell } from "@/pages/auth/AuthShell";
import { api, errMsg } from "@/lib/api";

export function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    try { await api.post("/auth/forgot-password", { email }); setSent(true); } catch (err) { toast.error(errMsg(err)); }
  };
  return (
    <AuthShell title="Reset your password" subtitle="We'll email you a secure reset link.">
      {sent ? <p data-testid="forgot-sent" className="text-muted-foreground">If an account exists for {email}, a reset link is on its way. <Link to="/login" className="text-[#7c3aed] font-semibold">Back to login</Link></p> : (
        <form onSubmit={submit} className="space-y-5">
          <div className="space-y-2"><Label>Email</Label><Input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="forgot-email-input" className="h-12" /></div>
          <button className="btn-brand w-full" data-testid="forgot-submit-btn">Send reset link</button>
        </form>
      )}
    </AuthShell>
  );
}

export function ResetPassword() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const [pw, setPw] = useState("");
  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/auth/reset-password", { token: params.get("token"), password: pw });
      toast.success("Password updated. Please log in.");
      nav("/login");
    } catch (err) { toast.error(errMsg(err)); }
  };
  return (
    <AuthShell title="Choose a new password" subtitle="Minimum 8 characters.">
      <form onSubmit={submit} className="space-y-5">
        <div className="space-y-2"><Label>New password</Label><Input type="password" minLength={8} required value={pw} onChange={(e) => setPw(e.target.value)} data-testid="reset-password-input" className="h-12" /></div>
        <button className="btn-brand w-full" data-testid="reset-submit-btn">Update password</button>
      </form>
    </AuthShell>
  );
}
